import React, { Fragment, Component } from "react";
import { Button, Row, Col, Form, InputGroup, Container, OverlayTrigger, Tooltip } from "react-bootstrap";
import TableGroupsList from "./TableGroupsList";
import LoadingProgressBar from "../../spinners/LoadingProgressBar";
import "react-widgets/dist/css/react-widgets.css";
import $ from "jquery";
import EventFilter from "../../forms/dropdowns/EventFilter";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEraser, faLongArrowAltLeft, faLongArrowAltRight, faSync } from "@fortawesome/free-solid-svg-icons";
import NoPermission from "../../other/NoPermission";
import RowsDropdown from "../../forms/dropdowns/RowsDropdown";
import VerifiedGroupDropdown from "../../forms/dropdowns/VerifiedGroupDropdown";

class GroupsList extends Component {
    state = {
        showNOR: this.props.numberOfRecords,
        displayNOR: this.props.numberOfRecords,
        groupsList: this.props.dataList,
        originalGroupsList: this.props.dataList,
        searchedPhrase: "",
        loading: this.props.dataList ? false : true,
        selectedEvent: "all",
        eventsList: [],
        noPermission: false,
        selectedVerifiedGroup: "all",
    };

    handleSearch = (e) => {
        const searchedPhrase = e.target.value.toLowerCase();
        const { originalGroupsList } = this.state;
        this.setState({ searchedPhrase: searchedPhrase });
        if (searchedPhrase !== "") {
            let filteredGroups = originalGroupsList;
            //console.log(filteredGroups)
            filteredGroups = filteredGroups.filter(
                (el) =>
                    el.part_group_name.toString().toLowerCase().includes(searchedPhrase) ||
                    el.coordinator_fullname.toString().toLowerCase().includes(searchedPhrase) ||
                    el.count_part.toString().toLowerCase().includes(searchedPhrase)
            );
            this.setState({ groupsList: filteredGroups });
        } else {
            this.setState({ groupsList: originalGroupsList });
        }
    };

    handleDownloadData = () => {
        this.props.onResizeWindow("tableNotLoaded");
        this.setState({ loading: true });
        this.getGroupsList();
    };

    getGroupsList = async () => {
        const { fetchURL, onShowAlert, onGetDataList, t } = this.props;
        try {
            const response = await fetch(`${fetchURL}/groups-list`, {
                credentials: "include",
                method: "POST",
            });
            if (response.status === 200) {
                await response.json().then((fetchedData) => {
                    //console.log(fetchedData);
                    if (fetchedData.status === "noPermission") this.setState({ noPermission: true });
                    else if (fetchedData.status === "notLogged") this.props.onShowHomePage();
                    else if (fetchedData.status === false) onShowAlert({ variant: "danger", message: t(`error.${fetchedData.code}`) });
                    else {
                        const groupsList = fetchedData.groupsList;

                        this.setState(
                            {
                                groupsList: groupsList,
                                originalGroupsList: groupsList,
                            },
                            () => {
                                onGetDataList(groupsList);
                                this.setState({ loading: false });
                            }
                        );
                    }
                });
            }
        } catch (err) {
            onShowAlert({ variant: "danger", message: `${t("error.cannotFetchData")} (${err})` });
        }
    };

    componentDidMount() {
        this.getGroupsList();

        const { onResizeWindow } = this.props;
        onResizeWindow("tableNotLoaded");
        $(window).on("resize", function () {
            onResizeWindow("tableLoaded");
        });
    }

    componentDidUpdate() {
        const { onResizeWindow } = this.props;
        if (!this.state.loading) {
            $("#loadTable").fadeIn(200);
            if ($(".light-border").outerHeight() && $(".rest-info").outerHeight()) {
                onResizeWindow("tableLoaded");
            }
        }
    }

    render() {
        const { groupsList, searchedPhrase, loading, displayNOR, showNOR, noPermission, selectedVerifiedGroup } = this.state;
        const { onCheckUserPrivilage, onChangeNavAndPage, eventFilterValue, activeEvent, t, onShowHomePage } = this.props;

        let filteredGroupList = null;
        if (groupsList)
            filteredGroupList = groupsList.filter(
                (e) => (eventFilterValue === "all" || e.event_code === eventFilterValue) && (selectedVerifiedGroup === "all" || e.part_group_verified === selectedVerifiedGroup)
            );
        const currentPageParams = { nav: "groups", subpage: "groupsList", params: "" };
        return (
            <Fragment>
                {noPermission ? (
                    <NoPermission t={t} />
                ) : (
                    <Fragment>
                        <Container fluid className="pt-2 second-bar">
                            <Row>
                                <Col lg={3} xs={12}>
                                    <Form.Label>{t("form.searching")}</Form.Label>
                                    <InputGroup className="mb-3">
                                        <Form.Control type="text" placeholder={t("form.search")} onChange={this.handleSearch} value={searchedPhrase} />
                                        {searchedPhrase && (
                                            <InputGroup.Append>
                                                <Button
                                                    variant="outline-primary"
                                                    onClick={() =>
                                                        this.setState({
                                                            searchedPhrase: "",
                                                            groupsList: this.state.originalGroupsList,
                                                        })
                                                    }
                                                >
                                                    <FontAwesomeIcon icon={faEraser} />
                                                </Button>
                                            </InputGroup.Append>
                                        )}
                                    </InputGroup>
                                </Col>
                                <Col lg={1} md={3} xs={5}>
                                    <RowsDropdown
                                        t={t}
                                        defaultValue={this.props.numberOfRecords}
                                        onChangeValue={(event, { value }) => {
                                            this.setState({
                                                showNOR: value,
                                                displayNOR: value,
                                            });
                                            this.props.onChangeNOR(value);
                                        }}
                                    />
                                </Col>
                                <Col lg={2} md={3} xs={5}>
                                    <EventFilter
                                        t={t}
                                        eventFilterValue={this.props.eventFilterValue}
                                        eventsList={this.props.eventsList}
                                        onChangeEventFilter={this.props.onChangeEventFilter}
                                    />
                                </Col>
                                <Col xl={2} lg={2} md={2} xs={4}>
                                    <VerifiedGroupDropdown
                                        t={t}
                                        onShowHomePage={onShowHomePage}
                                        defaultValue={selectedVerifiedGroup}
                                        onChangeValue={(value) => {
                                            this.setState({
                                                selectedVerifiedGroup: value,
                                            });
                                        }}
                                    />
                                </Col>
                                <Col xl={{ offset: 0, span: 4 }} lg={{ span: 2, offset: 4 }} xs={12} className="text-left text-lg-right mt-lg-3 mt-lg-0 mb-3">
                                    <Button variant="outline-primary" onClick={this.handleDownloadData} className="btn-sync mr-3">
                                        <FontAwesomeIcon icon={faSync} />
                                    </Button>

                                    {onCheckUserPrivilage("ACCR_GROUP_ACTIONS") && (
                                        <Fragment>
                                            {activeEvent ? (
                                                <Button
                                                    variant="outline-primary"
                                                    type="button"
                                                    onClick={() => onChangeNavAndPage({ nav: "groups", subpage: "addGroup", params: "" }, currentPageParams)}
                                                >
                                                    {t("group.addGroup")}
                                                </Button>
                                            ) : (
                                                <OverlayTrigger key="left" placement="left" overlay={<Tooltip id={"tooltipDisabledNoChanges"}>{t("group.noActiveEvent")}</Tooltip>}>
                                                    <span className="d-inline-block">
                                                        <Button disabled variant="primary" style={{ pointerEvents: "none" }}>
                                                            {t("group.addGroup")}
                                                        </Button>
                                                    </span>
                                                </OverlayTrigger>
                                            )}
                                        </Fragment>
                                    )}
                                </Col>
                            </Row>
                        </Container>
                        <Container fluid className="content-body">
                            {loading ? (
                                <LoadingProgressBar t={t} />
                            ) : (
                                <div id="loadTable" style={{ display: "none" }}>
                                    <Row>
                                        <Col>
                                            <div className="table-responsive table-fixed-head">
                                                {filteredGroupList.length > 0 ? (
                                                    <Fragment>
                                                        <TableGroupsList
                                                            t={t}
                                                            onShowHomePage={onShowHomePage}
                                                            groupsList={filteredGroupList}
                                                            displayNOR={displayNOR}
                                                            onChangeNavAndPage={onChangeNavAndPage}
                                                            onCheckUserPrivilage={onCheckUserPrivilage}
                                                            activeEvent={activeEvent}
                                                        />
                                                        <div className="light-border"></div>
                                                    </Fragment>
                                                ) : (
                                                    <div className="text-center">{t("notFound")}</div>
                                                )}
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row className="rest-info py-3">
                                        <Col>
                                            {t("loaded")} {displayNOR > filteredGroupList.length ? filteredGroupList.length : displayNOR} {t("from")} {filteredGroupList.length}{" "}
                                            {t("records")}
                                        </Col>
                                        <Col className="text-center">
                                            {displayNOR >= filteredGroupList.length ? (
                                                <p className="opacity-4">
                                                    <FontAwesomeIcon icon={faLongArrowAltRight} />
                                                    <span className="px-3">{t("thatsAll")}</span>
                                                    <FontAwesomeIcon icon={faLongArrowAltLeft} />
                                                </p>
                                            ) : (
                                                <Button onClick={() => this.setState({ displayNOR: showNOR + displayNOR })} variant="outline-primary">
                                                    {t("loadMore")}
                                                </Button>
                                            )}
                                        </Col>
                                        <Col></Col>
                                    </Row>
                                </div>
                            )}
                        </Container>
                    </Fragment>
                )}
            </Fragment>
        );
    }
}

export default GroupsList;
